/** @format */

import React from "react";
import Cbtor from "../assets/images/cbtor.png";
import Dsc from "../assets/images/dsc.png";
import Calculator from "../assets/images/calculator.jpg";
import Manager from "../assets/images/manager.jpg";

const Projects = () => {
	return (
		<>
			<div className="row hidden">
				<div className="col-lg">
					<h4 className="font-weight-bold project-hero">
						Previous Projects
					</h4>
					<div className="row">
						<div className="col-6 col-md-6 col-lg-3 px">
							<div className="project">
								<img
									src={Cbtor}
									className="image-fluid"
									alt=""
								/>
								<h5>CBTor</h5>
								<p>
									A CBT platform to prepare university
									freshmen on campus
								</p>
								<p>
									<a href="https://cbtor.dsckwasu.club">
										<i className="fab fa-cloudversify"></i>
									</a>
									<a href="https://github.com/kwasu-ng/cbtor">
										<i className="fab fa-github"></i>
									</a>
								</p>
							</div>
						</div>
						<div className="col-6 col-md-6 col-lg-3 px">
							<div className="project">
								<img src={Dsc} className="image-fluid" alt="" />
								<h5>DSC KWASU Website</h5>
								<p>
									The official website for KWASU Developer
									student Clubs
								</p>
								<p>
									<a href="https://dsckwasu.club">
										<i className="fab fa-cloudversify"></i>
									</a>
									<a href="https://github.com/kwasu-ng/vibranium">
										<i className="fab fa-github"></i>
									</a>
								</p>
							</div>
						</div>
						<div className="col-6 col-md-6 col-lg-3 px">
							<div className="project">
								<img
									src={Manager}
									className="image-fluid"
									alt=""
								/>
								<h5>Club Manager</h5>
								<p>
									A monitoring application built for local DSC
									chapters to monitor their team
								</p>
								<p>
									<a href="https://clubmanagerid.web.app">
										<i className="fab fa-cloudversify"></i>
									</a>
									<a href="https://github.com/Adiomojeed/clubmanager">
										<i className="fab fa-github"></i>
									</a>
								</p>
							</div>
						</div>
						<div className="col-6 col-md-6 col-lg-3 px">
							<div className="project">
								<img
									src={Calculator}
									className="image-fluid"
									alt=""
								/>
								<h5>React Calculator</h5>
								<p className="project-text">
									A calculator built with ReactJs to perform
									basic mathematical operations
								</p>
								<p>
									<a href="https://codecalculator.herokuapp.com">
										<i className="fab fa-cloudversify"></i>
									</a>
									<a href="https://github.com/Adiomojeed/react-calculator">
										<i className="fab fa-github"></i>
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Projects;
